if (!customElements.get('component-account-social-login')) {
  customElements.define('component-account-social-login', class AccountSocialLogin extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.isInvalid = false;
  }

  connectedCallback() {
    this.props = {
      facebookAppId: this.getAttribute('facebook-app-id'),
      facebookApiVersion: this.getAttribute('facebook-api-version'),
      googleClientId: this.getAttribute('google-client-id'),
      socialLoginTag: this.getAttribute('social-login-tag'),
      facebookLoginTag: this.getAttribute('facebook-login-tag'),
      googleLoginTag: this.getAttribute('google-login-tag'),
      cryptoSecret: this.getAttribute('crypto-secret'),
    };

    const googleLoginButton = this.querySelector('#google-login-btn');
    if (this.hasGoogleLogin()) {
      googleLoginButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.openGoogleLogin();
      });
    } else {
      googleLoginButton.style.display = 'none';
    }

    const faceLoginButton = this.querySelector('#facebook-login-btn');
    if (this.hasFacebookLogin()) {
      faceLoginButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.openFacebookLogin();
      });
    } else {
      faceLoginButton.style.display = 'none';
    }

    const loginErrorMessage = this.querySelector('.social-login__error');
    if (this.isInvalid) {
      loginErrorMessage.style.display = 'block';
    } else {
      loginErrorMessage.style.display = 'none';
    }
  }

  hasGoogleLogin() {
    return !!window.google?.accounts;
  }

  hasFacebookLogin() {
    return !!window.FB;
  }

  // Trigger Google login popup
  openGoogleLogin() {
    if (!this.hasGoogleLogin()) {
      this.invalidateLogin();
      return;
    }

    this.loading = true;

    // Attempt a Google sign in
    const googleClient = window.google.accounts.oauth2.initTokenClient({
      client_id: this.props.googleClientId,
      scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
      ux_mode: 'popup',
      callback: async (tokenResponse) => {
        this.access_token = tokenResponse.access_token;
        // Request user data
        const profile = await this.getUserProfileData(this.access_token);
        // Validate and attempt multipass sign in
        await this.checkDataAndSignIn(
          profile.email,
          profile.given_name,
          profile.family_name,
          this.props.googleLoginTag,
        );
      },
    });
    // Trigger google popup
    googleClient.requestAccessToken();
  }

  async getUserProfileData(accessToken) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${accessToken}`);
    const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers,
    });
    return await response.json();
  }

  // Trigger facebook login popup
  openFacebookLogin() {
    if (!this.hasFacebookLogin()) {
      this.invalidateLogin();
      return;
    }

    this.loading = true;

    // Initialize FB
    window.FB.init({
      appId: this.props.facebookAppId,
      cookie: true, // enable cookies to allow the server to access the session
      xfbml: true, // parse social plugins on this page
      version: this.props.facebookApiVersion,
    });

    // Initialize API
    window.FB.login((response) => {
      if (response.status === 'connected') {
        // If initialized, attempt Facebook sign in
        window.FB.api('/me?fields=email,first_name,last_name', async (userData) => {
          // Validate and attempt multipass sign in
          await this.checkDataAndSignIn(
            userData.email,
            userData.first_name,
            userData.last_name,
            this.props.facebookLoginTag,
          );
        });
      } else if (response.status === 'not_authorized') { // Failure
        this.invalidateLogin();
      } else {
        this.enableLogin();
      }
    }, { scope: 'email' });
  }

  // Unset loading state
  enableLogin() {
    this.loading = false;
  }

  // Set error state and re-enable elements
  invalidateLogin() {
    this.isInvalid = true;
    this.enableLogin();
  }

  // Validate email and trigger multipass
  async checkDataAndSignIn(email, firstName, lastName, signedInTag) {
    if (email) {
      this.isInvalid = false;
      await this.signInWithMultipass(email, firstName, lastName, signedInTag);
    } else {
      this.invalidateLogin();
    }
  }

  async multipassSignIn(payload) {
    const data = await getAuthData();
    if (!data) { return false; }
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': data.profileServiceKey,
    };
    let result = null;
    try {
      const response = await fetch(data.baseUrl + data.multipassEndpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        result = await response.json();
      }
    } catch (error) {
      console.error('Error during multipass sign in:', error);
    }
    return result;
  }


  // Sign into Shopify with multipass
  async signInWithMultipass(email, firstName, lastName, signedInTag) {
    // Prepare payload
    const payload = {
      email,
      firstName,
      lastName,
      tags: signedInTag,
      returnTo: `${window.location.origin}/account`,
      crossDomain: true,
    };

    const result = await this.multipassSignIn(payload);

    // Success
    if (result) {
      this.trackLoginEmail(email, signedInTag);
      this.multipassSuccess(result);
    } else {
      this.invalidateLogin();
    }
  }

  trackLoginEmail(email, signedInTag) {
    try {
      const cipherInstance = browserCrypto.createCipher(
        'aes-256-cbc',
        this.props.cryptoSecret,
      );
      const encryptedEmail = cipherInstance.update(email, 'utf8', 'hex');
      const finalEmailHash = encryptedEmail + cipherInstance.final('hex');

      window.sendGTMData && window.sendGTMData({
        event: 'login',
        email: finalEmailHash,
        source: signedInTag,
      });
    } catch (err) {
      console.error(err);
    }
  }

  // On multipass success, redirect to the multipass URL
  multipassSuccess(response) {
    const domain = window.location.host.includes('trythirdlove') ? 'trythirdlove.com' : 'thirdlove.com';
    jsCookie.set('_tl_is_customer', true, { expires: 18 * 30, domain });
    const params = window.getURLParams();
    let { url } = response;
    let returnTo = params.return_to;

    if (params.checkout_url) {
      returnTo = 'checkout';
    }

    if (returnTo) {
      url = `${url}?return_to=${encodeURIComponent(returnTo)}`;
    }

    document.location.replace(url);
  }
})
}
